import request from '@/utils/axios_gispai'
import store from "../../store";

// 微信登录
export function loginByWeChat(params) {
  return request({
    url: 'api/User/loginByWeChat',
    method: 'post',
    params: params
  })
}

export function loginByOfficialAccount(params) {
  return request({
    url: 'api/User/loginByOfficialAccount',
    method: 'post',
    params: params
  })
}

// 手机号是否重复
export function hasPhoenNumber(params) {
  return request({
    url: 'api/User/hasPhoenNumber',
    method: 'post',
    params: params
  })
}
// 发送验证码
export function SendSms(params) {
  return request({
    url: 'api/Common/SendSms',
    method: 'post',
    params: params
  })
}
// 检查验证码是否正确
export function checkMobileCode(params) {
  return request({
    url: 'api/Common/checkMobileCode',
    method: 'post',
    params: params
  })
}
// 绑定手机号
export function bindPhoen(params) {
  return request({
    url: 'api/User/bindPhoen',
    method: 'post',
    data: params
  })
}
// 用户名是否重复
export function hasUserName(params) {
  return request({
    url: 'api/User/hasUserName',
    method: 'post',
    params: params
  })
}
//绑定用户名及密码
export function bindNameAndPass(params) {
  return request({
    url: 'api/User/bindNameAndPass',
    method: 'post',
    data: params
  })
}
//获取用户信息
export function getUser(params) {
  store.commit("setPrivateCrows", "");
  return request({
    url: 'api/User/getUser',
    method: 'post',
    params: params
  })
}
//解绑手机号
export function unbindPhoen(params) {
  return request({
    url: 'api/User/unbindPhoen',
    method: 'get',
    params: params
  })
}
//修改密码
export function changePasswordForce(params) {
  return request({
    url: 'api/User/changePasswordForce',
    method: 'get',
    params: params
  })
}

//修改密码(新)
export function changePasswordNew(params) {
  return request({
    url: '/api/User/changeUserPassword',
    method: 'post',
    data:params
  })
}


// 退出登录
export function exit(userId, loginType) {
  store.commit("setPrivateCrows", "");
  return request({
    url: `api/User/exit?userId=${userId}&loginType=${loginType}`,
    method: 'post',
  })
}

//获取许可2-非用户登录许可
export function GetToken2(params) {
  return request({
    url: 'api/User/GetToken2',
    method: 'get',
    params: params
  })
}
//获取用户自定义工具条
export function getToolButton(params) {
  return request({
    url: 'api/ToolBar/getToolButton',
    method: 'get',
    params: params
  })
}
//用户添加自定义工具条
export function addOrUpdateToolButton(params) {
  return request({
    url: 'api/ToolBar/addOrUpdateToolButton',
    method: 'post',
    data: params
  })
}

//获取员价格信息
export function getAllMemberInfos(params) {
  return request({
    url: 'api/User/getAllMemberInfos',
    method: 'get',
    data: params
  })
}
//会员升级
export function userToVIP(params) {
  return request({
    url: 'api/User/userToVIP',
    method: 'post',
    data: params
  })
}

export function seniorToSupper(params) {
  return request({
    url: 'api/User/SeniorToSupper',
    method: 'post',
    data: params
  })
}

export function getMemberUpgrade(params) {
  return request({
    url: 'api/User/GetMemberUpgrade',
    method: 'post',
    data: params
  })
}

//更新token
export function refreshWeChat(params) {
  return request({
    url: 'api/User/refreshWeChat',
    method: 'get',
    params: params
  })
}

//登录
export function login(params) {
  return request({
    url: 'api/User/login',
    method: 'post',
    data: params
  })
}

// 获取推送
export function GetExtentsionAll(params) {
  return request({
    url: 'api/User/GetExtentsionAll',
    method: 'get',
    params: params
  })
}
export function getUserPowers(params) {
  return request({
    url: 'api/User/getUserPowers',
    method: 'get',
    params: params
  })
}

// 微信配置
export function GetWebChatLocationParam(params) {
  return request({
    url: 'api/Common/GetWebChatLocationParam',
    method: 'get',
    params: params
  })
}

// 众包验证是否关注公众号
export function isSubscribeByUserId(params) {
  return request({
    url: 'api/User/isSubscribeByUserId',
    method: 'get',
    params: params
  })
}
// 众包验证是否关注公众号
export function updateRealName(params) {
  return request({
    url: 'api/User/updateRealName',
    method: 'get',
    params: params
  })
}

export function loginPro(params) {
  return request({
    url: 'api/User/login',
    method: 'post',
    data: params
  })
}
export function creatPro(params) {
  return request({
    url: 'api/User/creat',
    method: 'post',
    data: params
  })
}

export function updateTeamUser(params) {
  return request({
    url: 'api/User/UpdateTeamUser',
    method: 'post',
    data: params
  })
}

export function getUserLevelType(params) {
  return request({
    url: 'api/User/getUserLevelType',
    method: 'get',
    params: params
  })
}

export function bindTeam(params) {
  return request({
    url: 'api/User/BindTeam',
    method: 'post',
    data: params
  })
}
export function creatUser(params) {
  return request({
    url: 'api/User/creatuser',
    method: 'post',
    data: params
  })
}
export function CreateByWeOpenId(params) {
  return request({
    url: 'api/User/CreateByWeOpenId',
    method: 'post',
    data: params
  })
}
export function getAllMemberInfoPrices(params) {
  return request({
    url: 'api/User/getAllMemberInfoPrices',
    method: 'get',
    params: params
  })
}

export function getUserByCode(params) {
  return request({
    url: 'api/User/getUserByGUID',
    method: 'post',
    data: params
  })
}

